export const USER_TOKEN_KEY = 'userToken';
export const USER_EMAIL = 'currentUserEmail'
export const TWILIO_USER_TOKEN_KEY = 'twilioUserToken';
export const LANDBOT_TOKEN = '@landbot/core/storage'
